import { render, staticRenderFns } from "./CoreTechnology.vue?vue&type=template&id=420b5ca5&scoped=true&"
import script from "./CoreTechnology.vue?vue&type=script&lang=js&"
export * from "./CoreTechnology.vue?vue&type=script&lang=js&"
import style0 from "./CoreTechnology.vue?vue&type=style&index=0&id=420b5ca5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b5ca5",
  null
  
)

export default component.exports